import { render, staticRenderFns } from "./WeComNotify.vue?vue&type=template&id=42c68773&scoped=true&"
import script from "./WeComNotify.vue?vue&type=script&lang=js&"
export * from "./WeComNotify.vue?vue&type=script&lang=js&"
import style0 from "./WeComNotify.vue?vue&type=style&index=0&id=42c68773&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c68773",
  null
  
)

export default component.exports